import React, { useState } from 'react'
import './VideoSection.css'
import { LuArrowLeft, LuArrowRight } from 'react-icons/lu'
import { FaPlay, FaTimes } from 'react-icons/fa'
import Carousel from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Thumb1 from '@resources/imgs/home/video-section/thumb-1.png'
import Thumb2 from '@resources/imgs/home/video-section/thumb-2.png'
import Thumb3 from '@resources/imgs/home/video-section/thumb-3.png'
import Thumb4 from '@resources/imgs/home/video-section/thumb-4.png'
import Thumb5 from '@resources/imgs/home/video-section/thumb-5.png'
import Thumb6 from '@resources/imgs/home/video-section/thumb-6.png'
import Thumb7 from '@resources/imgs/home/video-section/thumb-7.png'

const videos = [
  { id: 'wyceDDt_81w', title: 'Como solicitar uma pré-reserva do doador pelo Portal', duration: '0:55', thumb: Thumb1 },
  { id: 'IDrqa1NB9UU', title: 'C⁠omo adicionar o Photomatching na solicitação de pré-reserva pelo Portal?', duration: '1:11', thumb: Thumb2 },
  { id: 'W4hrqqWDpEY', title: 'Como realizar o pagamento e assinatura de contrato pelo Portal?', duration: '1:30', thumb: Thumb3 },
  { id: '3nw40zPcFpQ', title: 'Como acompanhar o meu pedido pelo Portal?', duration: '1:04', thumb: Thumb4 },
  { id: 'vSyiXvRuihQ', title: '⁠⁠Como navegar pelo perfil completo dos doadores de sêmen?', duration: '2:08', thumb: Thumb5 },
  { id: 'J9V6TaRzNNU', title: 'Como verificar disponibilidade e valores da amostra de sêmen do seu doador?', duration: '0:36', thumb: Thumb6 },
  { id: '_yudJLSYnls', title: 'Como usar os filtros para encontrar o seu doador', duration: '1:28', thumb: Thumb7 },
]

const PrevArrow = ({ onClick }: any) => (
  <button type="button" className="video-nav-arrow" onClick={onClick} aria-label="Anterior">
    <LuArrowLeft size={16} />
  </button>
)

const NextArrow = ({ onClick }: any) => (
  <button type="button" className="video-nav-arrow" onClick={onClick} aria-label="Próximo">
    <LuArrowRight size={16} />
  </button>
)

const VideoSection: React.FC<any> = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [lightboxVideoId, setLightboxVideoId] = useState<string | null>(null)

  const active = videos[activeIndex]

  const carouselSettings = {
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    afterChange: (index: number) => setActiveIndex(index),
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
    ],
  }

  return (
    <section className="video-section">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <span className="video-kicker d-block font-weight-bold text-uppercase mb-1" style={{ color: '#FA5A84' }}>Passo a Passo</span>
          <h2 className="video-title font-weight-bold text-dark mb-0">Entenda cada etapa dessa jornada</h2>
        </div>
      </div>

      <div
        onClick={() => setLightboxVideoId(active.id)}
        className="video-featured d-block text-decoration-none position-relative overflow-hidden"
        style={{ borderRadius: 16, cursor: 'pointer' }}
      >
        <img
          src={active.thumb}
          alt={active.title}
          className="w-100 video-featured-img"
          style={{ objectFit: 'cover', display: 'block', maxHeight: 650 }}
        />
        <div
          className="position-absolute w-100 h-100"
          style={{ top: 0, left: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.05) 40%, rgba(0,0,0,0.55) 100%)' }}
        />
        <div
          className="position-absolute d-flex align-items-center justify-content-center"
          style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}
        >
          <div className="play-badge-lg d-flex align-items-center justify-content-center rounded-circle" style={{ width: 64, height: 64, backgroundColor: '#FA5A84' }}>
            <FaPlay className="ml-1" size={20} style={{ color: '#fff' }} />
          </div>
        </div>
        <div className="position-absolute" style={{ bottom: 20, left: 24 }}>
          <p className="font-weight-bold text-white mb-0" style={{ fontSize: '1rem' }}>{active.title}</p>
          <p className="text-white mb-0" style={{ fontSize: '0.8125rem', opacity: 0.85 }}>{active.duration}</p>
        </div>
      </div>

      <div className="mt-3">
        <Carousel {...carouselSettings}>
          {videos.map((video, index) => (
            <div key={`${video.id}-${index}`} className="px-2">
              <button
                type="button"
                className="video-thumb-card w-100 p-0 text-left"
                onClick={() => setActiveIndex(index)}
                style={{
                  borderRadius: 12,
                  overflow: 'hidden',
                  border: `2px solid ${index === activeIndex ? '#FA5A84' : 'transparent'}`,
                  backgroundColor: '#EFEFEF',
                }}
              >
                <div className="position-relative overflow-hidden">
                  <img
                    src={video.thumb}
                    alt={video.title}
                    className="w-100 video-thumb-img"
                    style={{ objectFit: 'cover', display: 'block' }}
                  />
                  <div
                    className="position-absolute d-flex align-items-center justify-content-center"
                    style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}
                  >
                    <div className="d-flex align-items-center justify-content-center rounded-circle bg-white" style={{ width: 36, height: 36 }}>
                      <FaPlay className="ml-1" size={12} style={{ color: '#FA5A84' }} />
                    </div>
                  </div>
                </div>
                <div className="video-thumb-info" style={{ backgroundColor: '#EFEFEF', padding: '10px 12px 12px' }}>
                  <p className="font-weight-bold text-dark mb-0 text-left" style={{ fontSize: '0.8125rem', lineHeight: 1.35 }}>{video.title}</p>
                  <p className="mb-0 text-muted" style={{ fontSize: '0.75rem', marginTop: 2 }}>{video.duration}</p>
                </div>
              </button>
            </div>
          ))}
        </Carousel>
      </div>

      {lightboxVideoId && (
        <div
          className="video-lightbox-overlay"
          onClick={() => setLightboxVideoId(null)}
        >
          <div className="video-lightbox-content" onClick={e => e.stopPropagation()}>
            <button
              type="button"
              className="video-lightbox-close"
              onClick={() => setLightboxVideoId(null)}
              aria-label="Fechar"
            >
              <FaTimes size={20} />
            </button>
            <div className="video-lightbox-ratio">
              <iframe
                src={`https://www.youtube.com/embed/${lightboxVideoId}?autoplay=1`}
                title="YouTube video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="video-lightbox-iframe"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default VideoSection
